<i18n>
{
  "de": {
    "followHere": "Folge {artist} hier!"
  },
  "en": {
    "followHere": "Follow {artist} here!"
  }
}
</i18n>

<template>
  <div>
    <!-- Navbar mode: just the button with mobile styling -->
    <a
      v-if="navbarMode"
      href="#"
      class="follow-navbar-button follow-banner-button button is-outlined is-white is-large navbar-mobile-button"
      @click="follow"
    >
      <strong>
        {{
          $t('followHere', { artist: artist.nickname })
        }}
      </strong>
    </a>

    <!-- Default mode: hero section with button -->
    <section
      v-else
      class="hero is-primary"
    >
      <div class="has-text-centered follow-banner">
        <a
          href="#"
          class="follow-banner-button button is-outlined is-white is-large mt-20 mb-10"
          @click="follow"
        >
          <strong>
            {{
              $t('followHere', { artist: artist.nickname })
            }}
          </strong>
        </a>
      </div>
    </section>

    <modal
      v-if="showFollowerModal"
      :backdropClose="true"
      :defaultHeader="false"
      :defaultFooter="true"
      @close="closeFollowModal"
    >
      <div slot="body">
        <div class="is-overlay">
          <section class="scale-hack">
            <div class="content">
              <div class="modal-card animated slideInDown login-modal pt-10 pl-10 pr-10">
                <follower-login @logged="closeFollowModal" />
              </div>
            </div>
          </section>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import followerLogin from '~/components/follower-login'
import modal from '~/components/modal'

export default {
  components: {
    followerLogin, modal
  },
  props: {
    navbarMode: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showFollowerModal: false
  }),

  mounted() {
    this.$root.$on('showGlobalFollowerModal', this.openFollowModal)
  },
  beforeDestroy() {
    this.$root.$off('showGlobalFollowerModal', this.openFollowModal)
  },

  methods: {
    ...mapActions(['setFollowArtist', 'refreshFollowerPosts']),
    async follow() {
      if (this.isAuthenticated) {
        const data = await this.apiPost(`/api/private/${this.artist.urlAlias}/follow/subscribe`, null, null)
        if (data && data.ok) {
          await this.setFollowArtist(true)
          await this.refreshFollowerPosts({ urlAlias: this.artist.urlAlias })
          this.sendFlashMessage()
        }
      } else {
        this.showFollowerModal = true
      }
    },
    openFollowModal() {
      this.showFollowerModal = true
    },
    closeFollowModal() {
      this.showFollowerModal = false
    },
    sendFlashMessage() {
      const imageId = this.artist.profile.imgs.avatar.name
      const flashConfig = {
        blockClass: 'flash-gn-profile-success'
      }
      if (this.avatarImageId) {
        flashConfig.icon = `/services/media/image/${this.artist._id}/${imageId}/128/0/image.webp`
      }
      this.$root.$emit('flash', {
        type: 'toasts.followship.created',
        state: 'success',
        flashConfig,
        payload: {
          artist: this.artist.nickname
        }
      })
    }
  },
  computed: {
    avatarImageId() {
      if (
        !this.artist.profile ||
        typeof this.artist.profile.imgs.avatar === 'string'
      ) {
        return null
      }
      return this.artist.profile.imgs.avatar.name
    },
    ...mapState(['artist', 'isAuthenticated'])
  }
}
</script>

<style lang="scss">
@import 'assets/sass/_variables';

.follow-banner {
  padding-bottom: 10px !important;
}
@media only screen and (max-width: $mobile) {
  .follow-banner {
    padding: 10px 0 10px 0 !important;
  }
}
</style>
